import { abTest } from '@/store/store'

const initState = {
  uuidInfo: '', // 用户唯一标识，uuid
  abTestPlan: '', // 记录进入当前方案，
  // semtestBannerForm: true, // banner右侧form表单,abTest中的b方案
}
const mutations = {
  setUuidInfo(state: abTest, payload: any) {
    state.uuidInfo = payload
  },
  setAbTestPlan(state: abTest, payload: any) {
    state.abTestPlan = payload
  },
  // setSemtestBnnnerForm(state: abTest, payload: any) {
  //     state.semtestBannerForm = payload
  // }
}

export default {
  namespaced: true,
  state: initState,
  mutations,
}
